const emailUrls = {
    fetchTemplates: {
        url: '/mailTemplates/'
    }
};

export default emailUrls;
